module.exports.AxiosSingular = require('./axios-singular').default;